import { BaseTable } from '@sede-enterprise/shell-ds-react-framework';
import React, { useState } from 'react';
import { IBiaReportTableData } from '../../../../../Types/types2';
import { SOURCE_UOM } from '../../../../../api/constants';
import CellRenderer from './CellRenderer';
import {
  ColumnDef,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
} from '@tanstack/react-table';
export interface PaginationState {
  pageIndex: number;
  pageSize: number;
}

export const BiaReportTable = ({ biaData }: { biaData: IBiaReportTableData }) => {
  const [paginationState, setPaginationState] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 4,
  });
  const [sorting, setSorting] = useState<SortingState>([]);
  let columns: ColumnDef<unknown, string>[] = [];
  // Inside your main component
  if (biaData.length > 0) {
    const firstRow = biaData[0];
    const keys = Object.keys(firstRow);
    columns = keys
      .filter((key) => key !== SOURCE_UOM)
      .map((key) => ({
        header: key.toUpperCase().replace(/_/g, ' '),
        accessorKey: key,
        cell: (info) => CellRenderer(info.getValue(), info.column.id)
      })) as ColumnDef<unknown, string>[];

    // Add SOURCE_UOM column at the end
    if (keys.includes(SOURCE_UOM)) {
      columns.push({
        header: SOURCE_UOM,
        accessorKey: SOURCE_UOM,
        cell: (info) => CellRenderer(info.getValue(), info.column.id)
      } as ColumnDef<unknown, string>);
    }
  }

   const handlePaginationChange = async (
    newPaginationState: React.SetStateAction<PaginationState>,
  ) => {
    setPaginationState(newPaginationState);
  };

  const { pageSize, pageIndex } = paginationState;
  const tableOptions = {
    state: {
      pagination: { pageSize, pageIndex },
      sorting,
    },
      getPaginationRowModel: getPaginationRowModel(),
      getSortedRowModel: getSortedRowModel(),
      onPaginationChange: handlePaginationChange,
      onSortingChange: setSorting,
  };

  return (
    <BaseTable
      columns={columns as any}
      data={biaData as unknown[]}
      size='large'
      width={'100%'}
      data-testid='base-table'
      tableOptions={tableOptions as unknown as Object}
      style={{ border: '1px solid #C0C0C0' }}
    />
  );
};